import { PayloadAction } from '@reduxjs/toolkit';
import { TemplateState } from 'src/store/template/types';

const setTemplateCanAddPagesReducer = (state: TemplateState, action: PayloadAction<boolean>) => {
  state.canAddPages = action.payload;
};

export default setTemplateCanAddPagesReducer;
